export default __webpack_public_path__ + "static/media/CNo.88-5.aa7503ce.jpg";